import React, { useEffect, useState } from "react";
import {
  useSearchParams,
  useNavigate,
} from "react-router-dom";
import api from "../api/api";

export default function QualityVendorList() {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [searchParams] = useSearchParams();

  const type = searchParams.get("type");

  useEffect(() => {
    load();
  }, [type]);

  const load = async () => {
    try {
      setLoading(true);

      const data = await api.get(
        `/vendors/quality-vendors?type=${type}`
      );

      console.log("QUALITY API:", data);

      setRows(data.data || data || []);
    } catch (err) {
      console.error(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">

      {/* Header */}
      <div className="flex items-center justify-between mb-6">

        <div>
          <h1 className="text-2xl font-bold text-sap-text">
            {type === "rework"
              ? "Rework Vendors"
              : "Accepted GRPO Vendors"}
          </h1>

          <p className="text-sm text-gray-500">
            Vendor Risk Management / Quality Inspection
          </p>
        </div>

        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 transition"
        >
          ← Back
        </button>

      </div>

      {/* Total Count */}
      <div className="mb-3 text-sm text-gray-500">
        Total Vendors : <b>{rows.length}</b>
      </div>

      {/* Table */}
      <div className="bg-white rounded-lg shadow border overflow-x-auto">

        <table className="w-full">

          <thead>

            <tr className="border-b bg-gray-50">

              <th className="p-3 text-left">
                Vendor
              </th>

              <th className="p-3 text-right">
                Quality Score
              </th>

              <th className="p-3 text-right">
                Rework %
              </th>

              <th className="p-3 text-right">
                Defective Qty
              </th>

            </tr>

          </thead>

          <tbody>

            {loading ? (

              <tr>
                <td
                  colSpan="4"
                  className="p-4 text-center"
                >
                  Loading...
                </td>
              </tr>

            ) : rows.length === 0 ? (

              <tr>
                <td
                  colSpan="4"
                  className="p-4 text-center"
                >
                  No Records Found
                </td>
              </tr>

            ) : (

              rows.map((row, index) => (

                <tr
                  key={index}
                  className="border-b hover:bg-gray-50"
                >
                  <td className="p-3">
                    {row["Vendor Name"] ||
                      row.vendor_name ||
                      "-"}
                  </td>

                  <td className="p-3 text-right">
                    {Number(
                      row["Quality_Score"] ||
                        row.Quality_Score ||
                        0
                    ).toFixed(2)}
                  </td>

                  <td className="p-3 text-right">
                    {Number(
                      row["Rework_Percentage"] ||
                        row.Rework_Percentage ||
                        0
                    ).toFixed(2)}
                    %
                  </td>

                  <td className="p-3 text-right">
                    {Number(
                      row["Defective_Qty"] ||
                        row.Defective_Qty ||
                        0
                    )}
                  </td>
                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

     

    </div>
  );
}